import { QueryKey } from "@tanstack/react-query";
import { SalesFilters } from "./sales.api";

export const SALES_KEYS = {
  SALES: "sales",
  GET_SALES_ANALYTICS: (filters?: SalesFilters): QueryKey => [
    SALES_KEYS.SALES,
    "analytics",
    filters,
  ],
  GET_SALES_REPORTS: (filters?: SalesFilters): QueryKey => [
    SALES_KEYS.SALES,
    "reports",
    filters,
  ],
  GET_REVENUE_BY_SERVICE: (filters?: SalesFilters): QueryKey => [
    SALES_KEYS.SALES,
    "revenue-by-service",
    filters,
  ],
  GET_TOP_CLIENTS: (filters?: SalesFilters): QueryKey => [
    SALES_KEYS.SALES,
    "top-clients",
    filters,
  ],
  GET_MONTHLY_TRENDS: (year: number, clientId?: string): QueryKey => [
    SALES_KEYS.SALES,
    "monthly-trends",
    { year, clientId },
  ],
}; 